import Cookies from 'js-cookie'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { BaseModalType } from '@context/ModalsContext'

import { Checkbox } from '@ui/components/Checkbox'
import { Modal } from '@ui/components/Modal'

import { AuthUser } from '@model/User'

interface Props {
  handleTrustDevice(data: AuthUser): void
  onCloseTrustModal(data: AuthUser): void
  data: AuthUser
}

export const TrustModal: BaseModalType<Props> = (props) => {
  const { handleTrustDevice, data, onCloseTrustModal } = props
  const [showAgain, setShowAgain] = useState(Cookies.get('showTrustAgain') !== 'false')
  const { t } = useTranslation()

  const handleSetShowAgain = (val: boolean) => {
    Cookies.set('showTrustAgain', val.toString(), { expires: 30 })
    setShowAgain(val)
  }

  return (
    <Modal>
      <Modal.Header>{t('TwoFactorAuth.Trust this device')}</Modal.Header>
      <Modal.Body>
        <Modal.Body.Text>
          {t(
            'TwoFactorAuth.If you choose to trust this device, you will not be asked for a verification code the next time you sign in within the next 30 days'
          )}
        </Modal.Body.Text>
      </Modal.Body>
      <Modal.Footer>
        <Modal.Footer.Top>
          <Checkbox size='sm' checked={!showAgain} onChange={(val) => handleSetShowAgain(!val)}>
            {t('TwoFactorAuth.Dont ask anymore')}
          </Checkbox>
        </Modal.Footer.Top>
        <Modal.Footer.Secondary onClick={() => onCloseTrustModal(data)}>
          {t('Not now')}
        </Modal.Footer.Secondary>
        <Modal.Footer.Primary onClick={() => handleTrustDevice(data)}>
          {t('Trust')}
        </Modal.Footer.Primary>
      </Modal.Footer>
    </Modal>
  )
}
